export default "__VITE_ASSET__DWcg5Hs8__"